import { Grid } from "@mui/material"


const Email = (props) => {


    return (

        <Grid container style={{ marginTop: 200, fontFamily: 'Raleway' }}>
            <Grid item xs={12} style={{ textAlign: 'center' }}>
                <img alt={'mail'} src={`${process.env.REACT_APP_R2_URL}/general/email.png`} style={{ height: 200 }}></img>
            </Grid>
            <Grid item xs={12} style={{ textAlign: 'center', fontSize: 30 }}>
                Verification Email has been sent!
            </Grid>
            <Grid item xs={12} style={{ textAlign: 'center' }}>
                Verify your account to complete your login
            </Grid>

        </Grid>
    )



}

export default Email